export enum UnitKeys{
    SPEED = "speed_unit",
    AREA = "area_unit",
    TEMPERATURE = "temperature_unit",
    RAINFALL = "rainfall_unit",
    WEIGHT = "weight_unit"
}